import { Box, useTheme, useMediaQuery } from '@mui/material';
import ManageTags from './components/ManageTags/ManageTags';

const ManageTagsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Tag management (editing, deleting, merging) is available to all users
  return (
    <Box px={isMobile ? '16px' : '32px'}>
      <ManageTags />
    </Box>
  );
};

export default ManageTagsPage;
